import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-127ae466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-logout com_bg2" }
const _hoisted_2 = { id: "wrapper1" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "com_mgb45 com_mgt100 com_fs26 com_medium1 com_center1" }, " ログアウトしました ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_copyright1 com_mgt100" }, "© 2025 Kaunet", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logoutImage,
        alt: _ctx.altText,
        class: "with-kaunet_logo-logout",
        style: {"margin-top":"0"}
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/login",
        class: "com_button1"
      }, {
        default: _withCtx(() => [
          _createTextVNode("ログインページ")
        ]),
        _: 1
      }),
      _hoisted_5
    ])
  ]))
}